import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "w100 pad14 fs18 fw600" }
const _hoisted_4 = { class: "w100 roomTableContent" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "thStatus" }),
  /*#__PURE__*/_createElementVNode("th", { class: "thName" }),
  /*#__PURE__*/_createElementVNode("th", { class: "thButtons" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoomCell = _resolveComponent("RoomCell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.fixTabRoomsByDay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fixTabRoomsByDay, (rooms, dateId, dateindex) => {
            return (_openBlock(), _createElementBlock("div", { key: dateindex }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(dateId), 1),
              _createElementVNode("table", _hoisted_4, [
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rooms, (room, roomindex) => {
                  return (_openBlock(), _createBlock(_component_RoomCell, {
                    key: `${room.id}${room.updatedAtText}${room.unread_num}-${room.starred}${roomindex}${room.rooms_voted_num}`,
                    room: room,
                    showRoomModal: _ctx.showRoomModal,
                    canDelete: true,
                    isLastCell: _ctx.currentTabLength - 1 == _ctx.currentRoomNum(room.room_id),
                    onGoRoom: ($event: any) => (_ctx.goRoomFromTr(room)),
                    onClickSummary: _ctx.clickSummary,
                    onShowMembersLinks: _ctx.showMembersLinks,
                    onShowPublicLink: _ctx.showPublicLink,
                    onCancelVoted: _ctx.cancelVoted,
                    onCancelAppo: _ctx.cancelAppo,
                    onCreateFeedback: _ctx.createFeedback,
                    onChangeActive: _ctx.changeActive,
                    onSearchByMember: _ctx.searchByMember,
                    onSearchByMag: _ctx.searchByMag,
                    onClickFormMember: _ctx.clickFormMember,
                    onEditPrivateMemo: _ctx.editPrivateMemo,
                    onEditOpenScheduleMemo: _ctx.editOpenScheduleMemo
                  }, null, 8, ["room", "showRoomModal", "isLastCell", "onGoRoom", "onClickSummary", "onShowMembersLinks", "onShowPublicLink", "onCancelVoted", "onCancelAppo", "onCreateFeedback", "onChangeActive", "onSearchByMember", "onSearchByMag", "onClickFormMember", "onEditPrivateMemo", "onEditOpenScheduleMemo"]))
                }), 128))
              ])
            ]))
          }), 128)),
          _hoisted_6
        ]))
      : _createCommentVNode("", true)
  ]))
}